import { render, staticRenderFns } from "./StrokeBottomIcon.vue?vue&type=template&id=25fd07ed&"
import script from "./StrokeBottomIcon.vue?vue&type=script&lang=js&"
export * from "./StrokeBottomIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports